import type React from "react";
import { createContext } from "react";

interface IFeaturePreviewContext {
  featurePreview: boolean;
  setFeaturePreview?: React.Dispatch<React.SetStateAction<boolean>>;
}

const featurePreviewContext = createContext<IFeaturePreviewContext>({
  featurePreview: false,
});

export type { IFeaturePreviewContext };
export { featurePreviewContext };
